<template>
  <span class="kbd kbd-sm">
    <template v-if="displayFunctionKey">
      {{ functionKey }}
    </template>
    <slot />
  </span>
</template>

<script setup>
import { computed } from 'vue';

defineProps({
  displayFunctionKey: {
    type: Boolean,
    default: true,
  },
});

const functionKey = computed(() => {
  const isMac = navigator.userAgent.toUpperCase().indexOf('MAC') >= 0;
  return isMac ? '⌘' : 'Ctrl+';
});
</script>
